export interface KcpAuthDto {
  skinIdx: string; // "1" (숫자이지만 string으로 처리)
  lang: string; // "ko" (언어 코드)
  res_cd: string; // "0000" (결과 코드, string)
  res_msg: string; // "성공" (결과 메시지, string)
  buyr_mail: string; // "test@test.co.kr" (이메일 주소, string)
  tran_cd: string; // "00100000" (트랜잭션 코드, string)
  trace_no: string; // "T00009Q4HDCMVAMG" (트랜잭션 추적 번호, string)
  ret_pay_method: string; // "card" (결제 수단, string)
  use_pay_method: string; // "100000000000" (결제 방법 코드, string)
  enc_data: string; // 암호화된 결제 데이터 (string)
  enc_info: string; // 암호화된 결제 정보 (string)
  ordr_idxx: string; // "TEST12345" (주문 ID, string)
  card_pay_method: string; // "KAKAO_MONEY" (카드 결제 방법, string)
  kcp_select_card_code: string; // "SKKO" (선택한 카드 코드, string)
  ordr_chk: string; // "TEST12345|100" (주문 검증 값, string)
}

export const kcpAuthDtoKeys: (keyof KcpAuthDto)[] = [
  "skinIdx",
  "lang",
  "res_cd",
  "res_msg",
  "buyr_mail",
  "tran_cd",
  "trace_no",
  "ret_pay_method",
  "use_pay_method",
  "enc_data",
  "enc_info",
  "ordr_idxx",
  "card_pay_method",
  "kcp_select_card_code",
  "ordr_chk",
];
